import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';
import { programId } from './programOptions';
import { FormattedHTMLMessage, IntlProvider } from 'react-intl';
class App extends Component {
    render() {

        return (
    <div>
        <div className="sid-header-logo-container">
            <img
                className="sid-logo-image"
                alt="Wall Street Journal"
                src="https://assets-resources.sheerid.com/wsj/images/wsj-logo-transparent.png"
            />
        </div>
        <div className="sid-greyBox">
            <div className="App">
                <VerificationForm programId={programId} />
            </div>
        </div>
        <IntlProvider>
            <div className="sid-footer-outside">
                <div className="sid-footer-outside__one">
                    <FormattedHTMLMessage
                        id="poweredByOutsideFooter"
                        defaultMessage="Verification services powered by SheerID. <a className='sid-link' href='https://verify.sheerid.com/student-faq/?pid={programId}' target='_blank'>SheerID FAQs</a>"
                        values={{
                            programId,
                        }} />
                </div>
            </div>
        </IntlProvider>
    </div>
        );
    }
}

export default App;
